import {IReportPerson} from "Data";
import { GeneralReportStore } from "./../Stores/GeneralReportStore";
import { observable } from "mobx";

export class TestReportStore extends GeneralReportStore {
    @observable ball: string = "-";
    @observable player: IReportPerson | undefined;    
}